import React, { useContext } from "react";
import { makeStyles, Box } from "@material-ui/core";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useNavigate, } from "react-router-dom";
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#fff",
    position: "relative",
    // height: "100vh",
    "@media(max-width:1280px)": {
      height: "auto !important",
    },
  },
  MainLayout: {
    height: "100vh",
    overflowX: "hidden",
  },

  footerSec: {
    position: "absolute",
    bottom: "0px",
    left: "0px",
    right: "0px",
  },
}));

const MainLayout = ({ children }) => {
  const classes = useStyles();
  const location = useLocation();
  const navigate = useNavigate();

  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  useEffect(() => {
    const userLoginEmail = localStorage.getItem("user_email");

    if (userLoginEmail) {
      // Redirect to previous page or default to "/"
      const redirectTo = location.state?.from || "/";
      navigate(redirectTo, { replace: true });
    } else {
      setIsCheckingAuth(false);
    }
  }, [navigate, location]);

  // ⛔ Stop rendering login UI until check is done
  if (isCheckingAuth) return null;
  return (
    <div className={classes.root}>
      <div
        style={
          location.pathname !== "/" ? { display: "block" } : { display: "none" }
        }
      ></div>
      <div className={classes.MainLayout}>{children}</div>
    </div>
  );
};

export default MainLayout;
